








import {Component, Prop, Vue} from 'vue-property-decorator'
import IconCustom from '@/components/lib/IconCustom.vue'
import {IModalStepCommon} from '@/entities'

@Component({
  components: {
    IconCustom
  }
})
export default class StepChainItem extends Vue {
  @Prop() readonly data!: IModalStepCommon
  @Prop({ default: false }) readonly selected?: boolean
  @Prop({ default: false }) readonly done?: boolean

  get name(): string {
    return this.data.name.toLowerCase();
  }

  get fillIcon(): string {
    return this.done ? 'ui-input-fill' : 'accent';
  }

}
